
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkItemFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkItemFeatures"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseWorkItemFeatures"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startAndDueDate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rollUp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFixed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"healthStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthStatus"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolledUpWeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolledUpCompletedWeight"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockedByCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blockingCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"iteration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iteration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iterationCadence"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemFeatureStatus"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"agentPlan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":710}};
    doc.loc.source = {"body":"#import \"~/work_items/list/graphql/base_work_item_features.fragment.graphql\"\n#import \"./work_item_feature_status.fragment.graphql\"\n\nfragment WorkItemFeatures on WorkItemFeatures {\n  ...BaseWorkItemFeatures\n  startAndDueDate {\n    type\n    dueDate\n    startDate\n    rollUp\n    isFixed\n  }\n  healthStatus {\n    healthStatus\n  }\n  weight {\n    weight\n    rolledUpWeight\n    rolledUpCompletedWeight\n  }\n  linkedItems {\n    blockedByCount\n    blockingCount\n  }\n  iteration {\n    iteration {\n      id\n      title\n      startDate\n      dueDate\n      webUrl\n      iterationCadence {\n        id\n        title\n      }\n    }\n  }\n  status {\n    ...WorkItemFeatureStatus\n  }\n  agentPlan {\n    content\n    contentHtml\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/work_items/list/graphql/base_work_item_features.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./work_item_feature_status.fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["WorkItemFeatures"] = oneQuery(doc, "WorkItemFeatures");
        
